<template>
  <div class="flex-1 flex flex-col min-h-0 min-w-0 bg-white divide-y">
    <div class="flex-none p-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <BaseFormSelect
            v-model="from"
            :options="fromOptions"
            default-option-label="Select Sender"
          />
          <BaseButton success :disabled="!from" @click="handleSendToAll"> Send To All </BaseButton>
        </div>
        <BaseButton primary outline @click="refreshPage">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-5 w-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </BaseButton>
      </div>
    </div>
    <div class="overflow-y-auto flex-1">
      <BaseFetchData :action="fetchContactRequests">
        <!-- props
          fetchData, status.loading, status.resolved, status.rejected, rejectReason
        -->
        <template #default="fetchDataProps">
          <ContactRequestList
            v-if="fetchDataProps.status.resolved && contactRequestsData && contactRequestsData.data"
            :contact-requests="contactRequestsData.data"
            :sms-message="smsMessage"
            :disable-send="disableSend"
            :on-send-sms-message="handleSendSmsMessage"
          />
        </template>
      </BaseFetchData>
    </div>
    <div v-if="paginated" class="flex-none p-4 grid grid-flow-col justify-items-stretch gap-3">
      <BaseButton primary outline :disabled="isFirstPage" @click="fetchPrevPage"> Prev </BaseButton>
      <BaseButton primary outline :disabled="isLastPage" @click="fetchNextPage"> Next </BaseButton>
    </div>
  </div>
</template>

<script>
import { pipelineStageContactRequestsClient, pipelineStageSmsMessagesClient } from '@/api/clients';
import ContactRequestList from './ContactRequestList.vue';

export default {
  components: {
    ContactRequestList,
  },
  props: {
    smsMessage: {
      type: Object,
      required: true,
    },
    pipelineStage: {
      type: Object,
      required: true,
    },
    fromOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contactRequestsData: null,
      from: null,
    };
  },
  computed: {
    disableSend() {
      return typeof this.from !== 'string';
    },
    currentPage() {
      return this.contactRequestsData?.meta?.current_page || 1;
    },
    lastPage() {
      return this.contactRequestsData?.meta?.last_page || 1;
    },
    paginated() {
      return this.lastPage > 1;
    },
    isFirstPage() {
      return this.currentPage === 1;
    },
    isLastPage() {
      return this.currentPage === this.lastPage;
    },
  },
  methods: {
    refreshPage() {
      this.fetchContactRequests(this.currentPage);
    },
    fetchPrevPage() {
      if (this.currentPage === 1) {
        return;
      }

      this.fetchContactRequests(this.currentPage - 1);
    },
    fetchNextPage() {
      if (this.currentPage === this.lastPage) {
        return;
      }

      this.fetchContactRequests(this.currentPage + 1);
    },
    fetchContactRequests(pageNumber = 1) {
      return pipelineStageContactRequestsClient
        .list(this.pipelineStage.id, {
          include: 'sms_message_tracking_logs,contact_phone_numbers',
          page: {
            number: pageNumber,
            size: 100,
          },
        })
        .then((response) => {
          this.contactRequestsData = response;

          return Promise.resolve(response);
        });
    },
    handleSendToAll() {
      this.handleSendSmsMessage();
    },
    handleSendSmsMessage(inputData = {}) {
      const data = {
        sms_message_id: this.smsMessage.id,
        from: this.from,
        ...inputData,
      };

      pipelineStageSmsMessagesClient.send(this.pipelineStage.id, data).then(() => {
        this.fetchContactRequests(this.currentPage);
        this.$emit('sms-message-manager:change');
      });
    },
  },
};
</script>
